import { useEffect, useState, useRef, useCallback } from "react";
import {
  PlusCircle,
  Package,
  Calendar,
  Barcode,
  Tag,
  User,
  Truck,
  DollarSign,
  FileText,
  XCircle,
  Save,
  Plus,
} from "lucide-react"; // npm i lucide-react
import AssetValuationTabs from "./AssetValuationTabs";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useApiFromGetPost from "../../hooks/useApiGetPost";

import { Tooltip } from "@mui/material";
import canUserSeeThis from "../common/CheckCanUserSeeThis";
import {
  Autocomplete,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  InputLabel,
  Select,
} from "@mui/material";
import useApi from "../../hooks/useApi";

import Modal from "../common/CommonModal";

import CreditCustomerList from "../common/CreditCustomerList";
import AddCategoryDialog from "./AddCategoryDialog";
import QRCode from "qrcode";
import axios from "axios";

import { Trash2 } from "lucide-react";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";

export default function RegisterAsset() {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "";

  const [currentAssetToEdit, setCurrentAssetToEdit] = useState(null);
  const navigate = useNavigate();

  const location = useLocation();
  const asset_object_from_list = location.state?.asset_object;

  const [currentMode, setCurrentMode] = useState("ENTRY");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [imageData, setImageData] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const barcodecanvasRef = useRef(null);

  const CURRENT_USER = localStorage?.getItem("currentUserName") || "admin";

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}T00:00:00`;
  };

  const getTodayDateForInput = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const initialDepreciationObject = {
    purchase_date: getTodayDateForInput(),
    start_date: getTodayDateForInput(),
    purchase_value: "",
    estimated_salvage_value: "",
    opening_book_value: "",
    depreciation_months: "",
    periodic_depreciation_amount: "",
    notes: "",
    sold_date: "",
    sold_value: "",
  };

  const assetConditions = [
    { key: "new", value: "Newly purchased, unused" },
    { key: "excellent", value: "Like new, no defects" },
    { key: "good", value: "Fully functional, minor wear" },
    { key: "fair", value: "Functional but visible wear" },
    { key: "poor", value: "Limited usability, needs frequent repair" },
    { key: "damaged", value: "Not fully functional, repair required" },
    { key: "under_repair", value: "Currently under maintenance" },
    { key: "out_of_order", value: "Not operational" },
    { key: "obsolete", value: "Technologically outdated" },
    { key: "idle", value: "Functional but unused" },
    { key: "scrap", value: "Beyond repair, disposal required" },
    { key: "disposed", value: "Sold / scrapped / written off" },
    { key: "lost", value: "Asset not traceable" },
    { key: "transferred", value: "Moved to another department / location" },
  ];

  const [condition, setCondition] = useState(assetConditions[0].value);
  const [category, setCategory] = useState("");
  const [open, setOpen] = useState(false);

  const [inputFieldAccountType, setInputFieldAccountType] = useState(null);

  const { request, loading: loadingSupplier } = useApi();

  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");

  const [suggestions, setSuggestions] = useState([]);

  const [modalState, setModalState] = useState({
    isOpen: false,
    type: "", // 'add', 'cr-list'
    customer: null,
  });

  const autocompleteRef = useRef();

  const {
    loading: loadinggetVoucherNumber,
    data: datagetVoucherNumber,
    get: getVoucherNumber,
  } = useApiFromGetPost();

  const {
    data: getDataEmployeeList,
    loading: getLoadingEmployeeList,
    error: getErrorEmployeeList,
    get: getEmployeeList,
  } = useApiFromGetPost();

  const {
    data: getDataAssetCategoryList,
    loading: getLoadingAssetCategoryList,
    error: getErrorAssetCategoryList,
    get: getAssetCategoryList,
  } = useApiFromGetPost();

  const {
    data: dataDefaultAccounts,
    loading: getLoadingDefaultAccounts,
    error: getErrorDefaultAccounts,
    get: getDefaultAccounts,
  } = useApiFromGetPost();

  const {
    data: dataPostRegisterAsset,
    loading: loadPostRegisterAsset,
    error: errrorPostRegisterAsset,
    post: postRegisterAsset,
  } = useApiFromGetPost();

  const initialDataForForm = {
    assetNo: "",
    regDate: "",
    barcode: "",
    assetName: "",
    shortName: "",
    custodian: "",
    custodian_name: "",
    supplier: "",
    voucherNo: "",
    specification_and_remarks: "",
    location: "",
  };

  const [depreciationList, setDepreciationList] = useState(null);
  const [supplierData, setSupplierData] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState(initialDataForForm);

  const [depreciationObject, setDepreciationObject] = useState(
    initialDepreciationObject,
  );

  const [
    selectedEmployeeObjectFromAutoComplete,
    setSelectedEmployeeObjectFromAutoComplete,
  ] = useState(null);

  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedDepreciationAccount, setSelectedDepreciationAccount] =
    useState(null);
  const [
    selectedAccumulatedDepreciationAccount,
    setSelectedAccumulatedDepreciationAccount,
  ] = useState(null);

  const [selectedAssetAccount, setSelectedAssetAccount] = useState(null);

  const [pendingFile, setPendingFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null); // For showing the user what they picked

  const handleSupplierChange = (event, newValue) => {
    console.log("Supplier data new Value", newValue);
    setSelectedSupplier(newValue);
    setSupplierData(newValue);

    console.log("Selected Supplier", newValue);
  };

  const fetchCreditSuppliers = async (query = "-") => {
    const safeQuery = encodeURIComponent(query);
    const url = `${BASE_URL}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${DEPARTMENT}/all/-/${safeQuery}`;
    try {
      const response = await request({
        url: url,
        method: "GET",
        timeout: 1000,
      });
      return response || [];
    } catch (err) {
      console.error("Failed to fetch credit suppliers", err);
      return [];
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "supplier") {
      fetchCreditSuppliers(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // ... logic remains same
    setTimeout(() => setLoading(false), 1500); // Mock delay
  };

  const generateDepreciationSchedule = async (objectForDepreciation) => {
    // if (selectedDepreciationAccount?.ACCOUNT?.trim()?.length === 0) {
    //   alert("please select Depreciation A/C");
    //   return;
    // }
    // if (selectedAccumulatedDepreciationAccount?.ACCOUNT?.trim()?.length === 0) {
    //   alert("please select Accumulated Depreciation A/C");
    //   return;
    // }
    // if (selectedAssetAccount?.ACCOUNT?.trim()?.length === 0) {
    //   alert("please select Asset A/C");
    //   return;
    // }
    // console.log("objectForDepreciation", objectForDepreciation);

    try {
      const res = await fetch(
        `${BASE_URL}/api/CRMGenerateDepreciation/${COMPANY_CODE}/${objectForDepreciation.opening_book_value}/${objectForDepreciation.depreciation_months}/${objectForDepreciation.start_date}`,
      );
      const data = await res.json();
      setDepreciationList(data);
    } catch (error) {
      console.error("API Error", error);
    } finally {
      setLoading(false);
    }
  };

  const callAssetCategoryList = () => {
    getAssetCategoryList(
      `${BASE_URL}/api/MasterList/${COMPANY_CODE}/ASSETCATEGORY/-`,
    );
  };

  const callGetDefaultAccounts = () => {
    getDefaultAccounts(
      `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/Scrn_code/DE/-/${DEPARTMENT}/-`,
    );
  };

  const initialUseEffect = async () => {
    if (asset_object_from_list) {
      setCurrentMode("EDIT");

      const response = await fetch(
        `${BASE_URL}/api/DocumentEditDetails/${COMPANY_CODE}/asset/${asset_object_from_list.ASSET_NO}/${DEPARTMENT}`,
      );
      const resultArray = await response.json();
      const result = resultArray[0];

      setCurrentAssetToEdit(result);

      console.log("result ", result);

      setFormData((prev) => ({
        ...prev,
        assetNo: result.AssetNo,
        regDate: result.RegDate,
        barcode: result.Barcode,
        assetName: result.AssetName,
        shortName: result.ShortName,
        custodian: result.empid,
        custodian_name: result.Custodian, // not in api list i have to pick from employee list then set
        supplier: result.account, // name is coming here not account number
        voucherNo: result.VoucherNo,
        specification_and_remarks: result.SoldNotes, //not in api list
        location: result.division, // not in api list
      }));

      setSelectedEmployeeObjectFromAutoComplete({
        EmpId: result.EmpId,
        Name: result.Custodian,
      });
      setCondition(result.Notes);

      setCategory(result.Category);

      setDepreciationObject((prev) => ({
        ...prev,

        purchase_date: result.PurchDate?.split("T")[0],
        start_date: result.startdate?.split("T")[0],
        purchase_value: result.Amount,
        estimated_salvage_value: result.SalvageValue,
        opening_book_value: result.BookValue,
        depreciation_months: result.DeprMonths,
        periodic_depreciation_amount: "", // not receiving from api
        notes: "", // not using this
        sold_date: result.SoldDate, // not receiving from api
        sold_value: result.SoldValue, // not receiving from api
      }));

      setSelectedSupplier({
        ACCOUNT: result.account,
        DESCRIPTION: result.acName,
      });
      setSupplierData({ ACCOUNT: result.account, DESCRIPTION: result.acName }); // name is coming here not account number

      setSelectedDepreciationAccount({
        ACCOUNT: result.Account1,
        DESCRIPTION: result.Account1_DESC,
      });
      setSelectedAccumulatedDepreciationAccount({
        ACCOUNT: result.Account2,
        DESCRIPTION: result.Account2_DESC,
      });
      setSelectedAssetAccount({
        ACCOUNT: result.Account3,
        DESCRIPTION: result.Account3_DESC,
      });
    } else {
      getVoucherNumber(
        `${BASE_URL}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/PE/-`,
      );

      callGetDefaultAccounts();
    }

    getEmployeeList(
      `${BASE_URL}/api/PersonalInfoList/${COMPANY_CODE}/ALL/YES/ALL/ALL/ALL/ALL`,
    );

    callAssetCategoryList();
  };
  useEffect(() => {
    initialUseEffect();
  }, []);

  useEffect(() => {
    if (datagetVoucherNumber) {
      setFormData((prev) => ({
        ...prev,
        assetNo: datagetVoucherNumber[0]?.NEXT_NO,
      }));
    }
  }, [datagetVoucherNumber]);

  const fetchSuggestions = useCallback(
    async (query) => {
      if (!query || query.trim().length === 0) {
        setSuggestions([]);
        return;
      }

      const freetext = query.trim();

      const result = await fetchCreditSuppliers(freetext);
      setSuggestions(result || []);
    },
    [BASE_URL, COMPANY_CODE, DEPARTMENT],
  );

  useEffect(() => {
    console.log("inputValue", inputValue);
    const debounceTimeout = setTimeout(() => {
      fetchSuggestions(inputValue);
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [inputValue, fetchSuggestions]);

  const closeModal = () => {
    setModalState({
      isOpen: false,
      type: "",
      customer: null,
    });
  };

  const getOptionLabel = (option) => {
    if (!option) return "";
    return option.DESCRIPTION || option.name || "";
  };

  const handleSaveCategory = (categoryName) => {
    callAssetCategoryList();
    // Add your API call here
  };

  const clickedOnRegisterAsset = async () => {
    if (!formData.assetNo) {
      alert("Asset number not present pleasee try later");
      return;
    }

    if (!formData.assetName) {
      alert("Please enter asset name");
      return;
    }

    console.log(
      "Number(depreciationObject.depreciation_months)",
      Number(depreciationObject.depreciation_months),
    );

    let department = localStorage.getItem("currentSelectedDepartment") || "-";

    // for image upload use same as faizan did in item assetimage no base 64 needed

    // if no depreciationList then pass only single object in array

    // if by any chance depreciationList becomes null or empty call api again

    let schedule_list_to_loop = depreciationList;

    console.log(
      Number(depreciationObject.purchase_value),
      Number(depreciationObject.opening_book_value),
      Number(depreciationObject.depreciation_months),
    );

    if (
      Number(depreciationObject.purchase_value) > 0 &&
      Number(depreciationObject.opening_book_value) > 0 &&
      Number(depreciationObject.depreciation_months) > 0 &&
      !depreciationList?.length
    ) {
      const res = await fetch(
        `${BASE_URL}/api/CRMGenerateDepreciation/${COMPANY_CODE}/${Number(depreciationObject.opening_book_value)}/${Number(depreciationObject.depreciation_months)}/${depreciationObject.start_date}`,
      );
      schedule_list_to_loop = await res.json();
    }

    let arrayToPassToAPI = [];

    if (schedule_list_to_loop?.length > 0) {
      if (
        selectedDepreciationAccount === null ||
        selectedDepreciationAccount?.ACCOUNT?.trim()?.length === 0
      ) {
        alert("please select depreciation account");
        return;
      }
      if (
        selectedAccumulatedDepreciationAccount === null ||
        selectedAccumulatedDepreciationAccount?.ACCOUNT?.trim()?.length === 0
      ) {
        alert("please select accumulated depreciation account");
        return;
      }
      if (
        selectedAssetAccount === null ||
        selectedAssetAccount?.ACCOUNT?.trim()?.length === 0
      ) {
        alert("please select asset account");
        return;
      }
      // image upload also needed
      arrayToPassToAPI = schedule_list_to_loop?.map((item) => {
        return {
          CmpCode: COMPANY_CODE,
          mode: currentMode,
          AssetNo: formData.assetNo, // pe passed getting number actually pe for purchase enquiry later we will change
          RegDate:
            currentMode === "EDIT"
              ? currentAssetToEdit?.RegDate
              : getTodayDate(),
          Barcode: formData.barcode, // qr code generation needed
          Category: category,
          AssetName: formData.assetName,
          ShortName: formData.shortName,
          Custodian: formData.custodian_name, // employee name
          account: supplierData?.ACCOUNT ? supplierData?.ACCOUNT : "",
          acName: supplierData?.DESCRIPTION ? supplierData?.DESCRIPTION : "",
          VoucherNo: formData.voucherNo,
          Amount: Number(depreciationObject.purchase_value),
          Notes: condition, // condition pass here // specificcation and details ui remove just pass value of condition no key needed
          DeprPerc: 0, // 0 to pass here
          DeprMonths: Number(depreciationObject.depreciation_months),
          DeprOpening: Number(depreciationObject.opening_book_value),
          SalvageValue: Number(depreciationObject.estimated_salvage_value),
          LastDeprDate: null, // null to pass here
          PurchDate: `${depreciationObject.purchase_date}T00:00:00`, // no future date possible
          BookValue: Number(depreciationObject.opening_book_value),
          Account1: selectedDepreciationAccount.ACCOUNT
            ? selectedDepreciationAccount.ACCOUNT
            : "",
          Account2: selectedAccumulatedDepreciationAccount.ACCOUNT
            ? selectedAccumulatedDepreciationAccount.ACCOUNT
            : "",
          Account3: selectedAssetAccount.ACCOUNT
            ? selectedAssetAccount.ACCOUNT
            : "",
          SoldDate: depreciationObject.sold_date
            ? depreciationObject.sold_date
            : null, // in what format to pass here
          SoldValue: depreciationObject.sold_value
            ? Number(depreciationObject.sold_value)
            : null, // in what format to pass here
          SoldNotes: formData.specification_and_remarks, // use this for  specification notes details place on top
          deptno: department,
          division: formData.location, //what to pass
          startdate: depreciationObject.start_date, // can slect future date
          empid: formData.custodian, // employee id
          user: CURRENT_USER, // username of looged in person
          Description: item.Description, // pass blank
          fromDate: item.FromDate ? item.FromDate.split("T")[0] : null, // confirm null is to be passed if no date
          toDate: item.ToDate ? item.ToDate.split("T")[0] : null, // confirm null is to be passed if no date
          LineAmount: Number(item.DepAmount), // pass null if no depreciation list //  // is it DepAmount same from deprc list
          PeriodCaption: item.PeriodCaption, // pass "" if no dpreciation list
        };
      });
    } else {
      arrayToPassToAPI = [
        {
          CmpCode: COMPANY_CODE,
          mode: currentMode,
          AssetNo: formData.assetNo, // pe passed getting number actually pe for purchase enquiry later we will change
          RegDate:
            currentMode === "EDIT"
              ? currentAssetToEdit?.RegDate
              : getTodayDate(),
          Barcode: formData.barcode, // qr code generation needed
          Category: category,
          AssetName: formData.assetName,
          ShortName: formData.shortName,
          Custodian: formData.custodian_name, // employee name
          account: supplierData?.ACCOUNT ? supplierData?.ACCOUNT : "",
          acName: supplierData?.DESCRIPTION ? supplierData?.DESCRIPTION : "",
          VoucherNo: formData.voucherNo,
          Amount: Number(depreciationObject.purchase_value),
          Notes: condition, // condition pass here // specificcation and details ui remove just pass value of condition no key needed
          DeprPerc: 0, // 0 to pass here
          DeprMonths: Number(depreciationObject.depreciation_months),
          DeprOpening: Number(depreciationObject.opening_book_value),
          SalvageValue: Number(depreciationObject.estimated_salvage_value),
          LastDeprDate: null, // null to pass here
          PurchDate: `${depreciationObject.purchase_date}T00:00:00`, // no future date possible
          BookValue: Number(depreciationObject.opening_book_value),
          Account1: selectedDepreciationAccount.ACCOUNT
            ? selectedDepreciationAccount.ACCOUNT
            : "",
          Account2: selectedAccumulatedDepreciationAccount.ACCOUNT
            ? selectedAccumulatedDepreciationAccount.ACCOUNT
            : "",
          Account3: selectedAssetAccount.ACCOUNT
            ? selectedAssetAccount.ACCOUNT
            : "",
          SoldDate: depreciationObject.sold_date
            ? depreciationObject.sold_date
            : null, // in what format to pass here
          SoldValue: depreciationObject.sold_value
            ? Number(depreciationObject.sold_value)
            : null, // in what format to pass here
          SoldNotes: formData.specification_and_remarks, // use this for  specification notes details place on top
          deptno: department,
          division: formData.location, //what to pass
          startdate: depreciationObject.start_date, // can slect future date
          empid: formData.custodian, // employee id
          user: CURRENT_USER, // username of looged in person
          Description: "", // pass blank
          fromDate: null, // confirm null is to be passed if no date
          toDate: null, // confirm null is to be passed if no date
          LineAmount: null, // pass null if no depreciation list //  // is it DepAmount same from deprc list
          PeriodCaption: "", // pass "" if no dpreciation list
        },
      ];
    }

    let serializedData = JSON.stringify(arrayToPassToAPI);

    console.log("serializedData", serializedData);

    let apiURL = `${BASE_URL}/api/CRMAssetReg`;
    postRegisterAsset(apiURL, serializedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  useEffect(() => {
    if (barcodecanvasRef.current) {
      if (formData.barcode) {
        QRCode.toCanvas(
          barcodecanvasRef.current,
          formData.barcode || "",
          {
            width: 200,
            margin: 2,
            color: {
              dark: "#000000",
              light: "#ffffff",
            },
          },
          (error) => {
            if (error) console.error(error);
            console.log("QR Code generated!");
          },
        );
      } else {
        // IF TEXT IS EMPTY: Clear the canvas so it looks blank
        const canvas = barcodecanvasRef.current;
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
  }, [formData.barcode]); // Re-run whenever text changes

  const getImageUrl = (itemFilePath) => {
    if (!itemFilePath || typeof itemFilePath !== "string") return "";

    // Normalize backslashes
    const normalizedPath = itemFilePath.replace(/\\/g, "/");

    // Extract filename
    const splitKey = "DOCUMENT_UPLOAD/";
    const extractedFileName = normalizedPath.includes(splitKey)
      ? normalizedPath.split(splitKey)[1]
      : normalizedPath.split("/").pop();

    if (!extractedFileName) return "";

    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let imageViewUrl = apiPaths[0]?.IMG_API_PATH;
    // ✅ Avoid double slashes
    return `${imageViewUrl}/DOCUMENT_UPLOAD/${extractedFileName}`.replace(
      /\/+/g,
      "/",
    );
  };

  const handlePrev = () => {
    setCurrentImageIndex((prev) =>
      prev > 0 ? prev - 1 : imageData.length - 1,
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) =>
      prev < imageData.length - 1 ? prev + 1 : 0,
    );
  };

  const handleAddImage = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";

    input.onchange = async (e) => {
      const file = e.target.files[0];

      if (!file) return;

      try {
        if (currentMode === "EDIT") {
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreviewUrl(reader.result);
          };
          reader.readAsDataURL(file);

          const result = await uploadImage(
            file,
            asset_object_from_list.ASSET_NO,
          );
        } else {
          setPendingFile(file);

          // Create a local URL so the user can see a preview immediately
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreviewUrl(reader.result);
          };
          reader.readAsDataURL(file);

          // upload only after getting auto id after image upload either success or falure then call next voucher number
          // const result = await uploadImage(file, formData.code);
          // console.log("Result upload image:", result);
        }
      } catch (error) {
        console.error("Upload error:", error);
        showSnackbar("Something went wrong during upload!", "error");
      }
    };

    input.click();
  };

  const updateItemImage = async (companyCode, itemCode) => {
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];
      const BASE_URL = apiPaths[0]?.API_CONFIG;

      const response = await axios.get(
        `${BASE_URL}/api/CRMItemImageUpdate/${companyCode}/${itemCode}`,
      );

      console.log("Item image update success:", response.data);
      return response.data;
    } catch (error) {
      console.error("Item image update failed:", error);
      throw error;
    }
  };

  let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
  let companyCode = localStorage.getItem("companyCode") || "-";
  let currentUserName = localStorage.getItem("currentUserName");

  const fetchImage = async () => {
    console.log("formData.assetNo call image inside");

    const url = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${companyCode}/DOCIMAGE/${formData?.assetNo}/ASSETIMAGE`;

    try {
      const response = await axios.get(url);
      console.log("FetchImage response.data:", response.data);

      const images = response.data.map((item) => {
        const relativePath = item.Imagepath.split("DOCUMENT_UPLOAD")[1];

        return {
          slno: item.slno,
          imagePath: "\\DOCUMENT_UPLOAD\\" + relativePath,
        };
      });

      setImageData(images);
      setCurrentImageIndex(0);
    } catch (error) {
      console.error("Error fetching image:", error);
      setImageData([]);
    }
  };

  const uploadImage = async (selectedFile, itemCode) => {
    if (!selectedFile) {
      console.error("No file selected");
      return;
    }

    try {
      const companyCode = localStorage.getItem("companyCode") || "-";

      const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];

      const formDataObject = new FormData();
      formDataObject.append("DOC_CODE", itemCode || "");
      formDataObject.append("DOC_TYPE", "ASSETIMAGE");
      formDataObject.append("file", selectedFile);
      formDataObject.append("cmpcode", companyCode);
      formDataObject.append("IMGBASE64", "test");
      formDataObject.append(
        "IMAGEPATH",
        `${apiPaths[0].IMG_SERVERPATH}\\DOCUMENT_UPLOAD`,
      );
      formDataObject.append("description", "test");

      const response = await axios.post(
        `${apiPaths[0].IMG_POST_PATH}/api/Image/upload`,
        formDataObject,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      console.log("Image Upload Success:", response.data);

      await updateItemImage(companyCode, itemCode);

      showSnackbar("Image uploaded successfully!", "success");

      if (currentMode === "EDIT") {
        fetchImage();

        setPendingFile(null); // Clear pending file after success
        setPreviewUrl(null);
      }
      // no need to call

      return response.data;
    } catch (error) {
      console.error("Image Upload Failed:", error);
      showSnackbar("Failed to upload image!", "error");

      setPendingFile(null); // Clear pending file after success
      setPreviewUrl(null);
    }
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleRemoveItem = async () => {
    if (!imageData?.length) return;

    const currentImage = imageData[currentImageIndex];
    if (!currentImage?.slno) return;

    try {
      const url = `${apiPaths[0]?.API_CONFIG}/api/CRMImageDelete`;

      const payload = [
        {
          CmpCode: companyCode,
          mode: "DELETE",
          docuId: currentImage.slno,
          comments: "Image removed",
          user: currentUserName,
        },
      ];

      await axios.post(url, payload);

      showSnackbar("Image removed successfully", "success");

      // Remove image from UI state
      setImageData((prev) =>
        prev.filter((img) => img.slno !== currentImage.slno),
      );

      // Adjust index safely
      setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : 0));
    } catch (error) {
      console.error("Failed to delete image:", error);
      showSnackbar("Failed to remove image", "error");
    }
  };

  useEffect(() => {
    console.log("formData.assetNo call image", formData);
    if (formData.assetNo) {
      console.log("formData.assetNo call image", formData.assetNo);
      fetchImage();
    }
  }, [formData.assetNo]);

  const getAccountByCode = (code) => {
    return dataDefaultAccounts.find((item) => item.Scrn_code === code)?.ACCOUNT;
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    if (dataDefaultAccounts) {
      if (dataDefaultAccounts?.length > 0) {
        setSelectedDepreciationAccount({
          ACCOUNT: getAccountByCode("DE-ACC1"),
        });
        setSelectedAccumulatedDepreciationAccount({
          ACCOUNT: getAccountByCode("DE-ACC2"),
        });
        setSelectedAssetAccount({ ACCOUNT: getAccountByCode("DE-ACC3") });
      }
    }
  }, [dataDefaultAccounts]);

  useEffect(() => {
    console.log("dataPostRegisterAsset", dataPostRegisterAsset);

    if (dataPostRegisterAsset?.result?.trim()?.toUpperCase() === "SAVED") {
      showSnackbar("Saved", "success");
      if (currentMode === "EDIT") {
        navigate("/asset_register_list");
      }

      // if new entry go to list only after uploading 1st image

      if (pendingFile) {
        console.log(
          "dataPostRegisterAsset?.result?.autoid ",
          dataPostRegisterAsset?.autoid,
        );
        uploadImage(pendingFile, dataPostRegisterAsset?.autoid);
        navigate("/asset_register_list");
      }

      // setDepreciationObject(initialDepreciationObject);
      // setFormData(initialDataForForm);

      // setSupplierData(null);
      // setCategory("");
      // setCondition(assetConditions[0].value ? assetConditions[0].value : "");
      // setSelectedEmployeeObjectFromAutoComplete(null);
      // setSelectedSupplier(null);
      // setSelectedDepreciationAccount(null);
      // setSelectedAccumulatedDepreciationAccount(null);
      // setSelectedAssetAccount(null);

      // if (pendingFile) {
      //   uploadImage(pendingFile, dataPostRegisterAsset?.result?.autoid);
      // }

      // if(currentMode === "ENTRY"){
      //   getVoucherNumber(
      //     `${BASE_URL}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/PE/-`
      //   );
      // }
    }
  }, [dataPostRegisterAsset]);

  return (
    <div className="min-h-screen bg-slate-50/50 p-4 md:p-8">
      <div className="mx-auto">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
              Register New Asset
            </h1>
            <p className="text-slate-500 mt-1">
              Fill in the details to add a new item to the inventory system.
            </p>
          </div>

          <div className="flex items-center justify-between pt-4 border-t border-slate-200">
            <button
              onClick={() => clickedOnRegisterAsset()}
              type="button"
              disabled={loadPostRegisterAsset}
              className="flex items-center gap-2 px-8 py-2.5 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 active:scale-95 rounded-xl shadow-lg shadow-indigo-200 transition-all disabled:opacity-70 disabled:pointer-events-none"
            >
              {loadPostRegisterAsset ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <Save className="w-4 h-4" />
              )}
              {loadPostRegisterAsset ? "Processing..." : "Register Asset"}
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          {/* Section 1: Basic Information */}
          <section className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/50 flex">
              <h2 className="text-sm font-semibold text-slate-700 uppercase tracking-wider me-2">
                General Information
              </h2>

              {currentMode === "ENTRY" && (
                <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
                  NEW ENTRY{" "}
                </span>
              )}
              {currentMode === "EDIT" && (
                <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded">
                  EDIT MODE
                </span>
              )}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-5">
                <Input
                  icon={<Package size={16} />}
                  label="Asset No"
                  name="assetNo"
                  value={formData.assetNo}
                  onChange={handleChange}
                  placeholder="AST-001"
                  required
                />
                <Input
                  icon={<Tag size={16} />}
                  label="Asset Name"
                  name="assetName"
                  value={formData.assetName}
                  onChange={handleChange}
                  placeholder=""
                  required
                />
                <Input
                  icon={<Tag size={16} />}
                  label="Short Name"
                  name="shortName"
                  value={formData.shortName}
                  onChange={handleChange}
                  placeholder=""
                />

                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase ml-1">
                    CUSTODIAN
                  </label>

                  <Autocomplete
                    sx={{ width: "300px" }}
                    options={getDataEmployeeList}
                    value={selectedEmployeeObjectFromAutoComplete}
                    getOptionLabel={(option) =>
                      option.Name ? option.Name : ""
                    }
                    onChange={(event, newValue) => {
                      console.log("selected employee", newValue);
                      if (newValue) {
                        setSelectedEmployeeObjectFromAutoComplete(newValue);
                        setFormData((prev) => ({
                          ...prev,
                          custodian: newValue.EmpId,
                          custodian_name: newValue.Name,
                        }));
                      } else {
                        setSelectedEmployeeObjectFromAutoComplete(null);
                        setFormData((prev) => ({
                          ...prev,
                          custodian: "",
                          custodian_name: "",
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Employee"
                        variant="outlined"
                        size="small"
                      />
                    )}
                    filterOptions={(options, { inputValue }) =>
                      options.filter(
                        (option) =>
                          option.EmpId.toLowerCase().includes(
                            inputValue.toLowerCase(),
                          ) ||
                          option.Name.toLowerCase().includes(
                            inputValue.toLowerCase(),
                          ),
                      )
                    }
                  />
                  <span style={{ fontSize: "12px" }}>
                    ID : {formData.custodian}
                  </span>
                </div>

                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase ml-1">
                    CATEGORY{" "}
                    <button className="ms-2" onClick={() => setOpen(true)}>
                      Add new
                    </button>
                    <AddCategoryDialog
                      open={open}
                      onClose={() => setOpen(false)}
                      onSave={handleSaveCategory}
                    />
                  </label>

                  <FormControl fullWidth size="small" style={{ marginTop: 4 }}>
                    <InputLabel id="asset-condition-label"></InputLabel>
                    <Select
                      labelId="asset-condition-label"
                      id="asset-condition-select"
                      value={category}
                      label={"Category"}
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      {getDataAssetCategoryList
                        ?.filter((item) => item.Description?.trim() != "")
                        .map((category) => (
                          <MenuItem
                            key={category.TranId}
                            value={category.Description}
                          >
                            {category.Description}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>

                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase ml-1">
                    CONDITION
                  </label>

                  <FormControl fullWidth size="small" style={{ marginTop: 4 }}>
                    <InputLabel id="asset-condition-label"></InputLabel>
                    <Select
                      labelId="asset-condition-label"
                      id="asset-condition-select"
                      value={condition}
                      label={"Condition"}
                      onChange={(e) => setCondition(e.target.value)}
                    >
                      {assetConditions.map((condition) => (
                        <MenuItem key={condition.key} value={condition.value}>
                          {condition.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <Input
                  icon={<Tag size={16} />}
                  label="Location"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder=""
                />
              </div>

              <div className="pt-6">
                <Input
                  icon={<Barcode size={16} />}
                  label="Barcode"
                  name="barcode"
                  value={formData.barcode}
                  onChange={handleChange}
                  placeholder="Scan or enter code"
                />

                {/* <canvas
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    width: "200px",
                  }}
                  ref={barcodecanvasRef}
                /> */}

                <div
                  style={{
                    height: "200px",
                    width: "200px",
                    marginTop: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                  }}
                >
                  {formData.barcode ? (
                    <canvas
                      ref={barcodecanvasRef}
                      style={{
                        width: "100%", // Tells the canvas to fill the 200px wrapper
                        height: "100%",
                      }}
                    />
                  ) : (
                    <span className="text-[10px] text-slate-400 font-bold uppercase text-center px-4">
                      QR Preview Area
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="px-6 ">
              <Input
                label="Specification and Remarks"
                name="specification_and_remarks"
                value={formData.specification_and_remarks}
                onChange={handleChange}
                placeholder="Specification and Remarks"
              />
            </div>
            <div className="px-8  pb-4 mt-2">
              <h1>Purchase details</h1>

              <div className="flex">
                <div className="pe-4 mt-3" style={{ minWidth: "300px" }}>
                  <Autocomplete
                    ref={autocompleteRef}
                    value={selectedSupplier}
                    onChange={handleSupplierChange}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    options={suggestions}
                    getOptionLabel={getOptionLabel}
                    loading={loadingSupplier}
                    filterOptions={(x) => x} // Disable built-in filtering
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Supplier"
                        variant="outlined"
                        size="small"
                        placeholder="Search supplier..."
                        onKeyDown={(e) => {
                          if (e.key === "F2") {
                            e.preventDefault();

                            // CLOSE AUTOCOMPLETE SUGGESTIONS
                            if (autocompleteRef.current) {
                              autocompleteRef.current.blur();
                            }
                            setModalState({
                              isOpen: true,
                              type: "cr-list",
                              customer: null,
                            });
                          }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingSupplier && (
                                <CircularProgress color="inherit" size={20} />
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <div className="flex items-center justify-between w-full">
                          <span>{option.DESCRIPTION || option.name}</span>
                          {option.ACCOUNT && (
                            <Chip
                              label={option.ACCOUNT}
                              size="small"
                              color={"primary"}
                              sx={{ height: 20, fontSize: 10 }}
                            />
                          )}
                        </div>
                      </li>
                    )}
                    noOptionsText={
                      inputValue.length === 0
                        ? "Start typing to search..."
                        : "No suppliers found"
                    }
                  />
                  <div className="p-3 bg-gray-100 flex justify-between rounded-lg">
                    <div>
                      <span className="text-sm text-gray-600">A/C:</span>{" "}
                      <span className="font-bold text-orange-600">
                        {supplierData?.ACCOUNT || "######"}
                      </span>
                    </div>
                    {/* <div>
                      <span className="text-sm text-gray-600">Balance: </span>
                      <span
                        className={`font-bold ${
                          supplierData?.BALANCE > 0
                            ? "text-green-600"
                            : supplierData?.BALANCE < 0
                            ? "text-red-500"
                            : "text-gray-600"
                        }`}
                      >
                        {supplierData?.BALANCE ?? "0"}
                      </span>
                    </div> */}
                  </div>
                </div>
                <Input
                  icon={<FileText size={16} />}
                  label="Voucher No"
                  name="voucherNo"
                  value={formData.voucherNo}
                  onChange={handleChange}
                />
              </div>
            </div>
          </section>

          <div style={{ width: "300px" }}>
            {previewUrl ? (
              <img
                src={previewUrl}
                alt="Preview"
                className="object-contain h-full"
              />
            ) : imageData && imageData.length > 0 ? (
              <div className="max-w-sm p-4 rounded shadow md:p-6">
                <div className="flex items-center justify-center h-48 mb-4 rounded overflow-hidden">
                  <img
                    src={getImageUrl(imageData[currentImageIndex]?.imagePath)}
                    alt={`Product ${currentImageIndex + 1}`}
                    className="object-contain h-full"
                    key={currentImageIndex}
                    onError={(e) => {
                      console.error("Image load error");
                      console.log(
                        "Failed URL:",
                        getImageUrl(imageData[currentImageIndex]),
                      );
                    }}
                  />
                </div>
                {/* Show image counter */}
                <div className="text-center text-sm text-gray-600 mb-2">
                  Image {currentImageIndex + 1} of {imageData.length}
                </div>
              </div>
            ) : (
              <div className="max-w-sm p-4 rounded shadow animate-pulse md:p-6">
                <div className="flex items-center justify-center h-48 mb-4 bg-gray-200 rounded dark:bg-gray-300">
                  <svg
                    className="w-10 h-10 text-gray-200 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 16 20"
                  >
                    <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"></path>
                    <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"></path>
                  </svg>
                </div>
                <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
                <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300 mb-2.5"></div>
                <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300 mb-2.5"></div>
                <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300"></div>
                <span className="sr-only">Loading...</span>
              </div>
            )}

            <div className="flex justify-between items-center mt-4">
              {imageData?.length > 1 && (
                <button
                  type="button"
                  onClick={handlePrev}
                  className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md shadow"
                >
                  <ChevronLeft className="w-4 h-4 text-gray-700" />
                </button>
              )}

              <Tooltip
                title={formData.assetNo === "" ? "Please enter code" : ""}
                arrow
              >
                {canUserSeeThis("AE") && (
                  <span>
                    <button
                      type="button"
                      onClick={handleAddImage}
                      disabled={!formData.assetNo}
                      className={`px-4 py-2  text-white rounded  transition flex justify-center items-center gap-2   
                ${
                  !formData.assetNo
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-500 hover:bg-green-700"
                }`}
                    >
                      <Plus className="w-3 h-4" />
                      <span className="text-sm">Add</span>
                    </button>
                  </span>
                )}
              </Tooltip>
              <Tooltip
                title={formData.assetNo === "" ? "Please enter code" : ""}
                arrow
              >
                {canUserSeeThis("AE") && (
                  <span>
                    <button
                      type="button"
                      onClick={handleRemoveItem}
                      className={`px-4 py-2 text-white rounded  transition flex justify-center items-center gap-2
                  ${
                    !formData.assetNo
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-red-500 hover:bg-red-700"
                  }
                  `}
                    >
                      <Trash2 className="w-3 h-4" />
                      <span className=" text-sm">Remove</span>
                    </button>
                  </span>
                )}
              </Tooltip>

              {imageData?.length > 1 && (
                <button
                  type="button"
                  onClick={handleNext}
                  className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md shadow"
                >
                  <ChevronRight className="w-4 h-4 text-gray-700" />
                </button>
              )}
            </div>
          </div>

          <AssetValuationTabs
            setDepreciationObject={setDepreciationObject}
            depreciationObject={depreciationObject}
            generateDepreciationSchedule={generateDepreciationSchedule}
            depreciationList={depreciationList}
            setDepreciationList={setDepreciationList}
            setSelectedDepreciationAccount={setSelectedDepreciationAccount}
            selectedDepreciationAccount={selectedDepreciationAccount}
            setSelectedAccumulatedDepreciationAccount={
              setSelectedAccumulatedDepreciationAccount
            }
            selectedAccumulatedDepreciationAccount={
              selectedAccumulatedDepreciationAccount
            }
            setSelectedAssetAccount={setSelectedAssetAccount}
            selectedAssetAccount={selectedAssetAccount}
          />
        </form>
      </div>
      <Modal
        isOpen={modalState.isOpen}
        onClose={closeModal}
        title={
          modalState.type === "add"
            ? "Add New Supplier"
            : modalState.type === "cr-list"
              ? "Select Supplier"
              : modalState.type === "job-list"
                ? "Select Job Code"
                : "Supplier"
        }
        size={modalState.type === "add" ? "xxl" : "xxl"}
        header={modalState.type === "add" ? false : true}
      >
        {modalState.type === "cr-list" && (
          <CreditCustomerList
            defaultType="Suppliers"
            handleCustomerSelect={(newValue) => {
              console.log("Supplier data new Value", newValue);
              setSelectedSupplier(newValue);
              setSupplierData(newValue);
              console.log("Selected Supplier", newValue);

              closeModal();
            }}
          />
        )}{" "}
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

function Input({
  label,
  type = "text",
  name,
  value,
  onChange,
  required,
  icon,
  placeholder,
}) {
  return (
    <div className="space-y-1.5">
      <label className="text-xs font-bold text-slate-500 uppercase ml-1">
        {label} {required && <span className="text-rose-500">*</span>}
      </label>
      <div className="relative group">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-500 transition-colors">
            {icon}
          </div>
        )}
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          className={`
            w-full bg-white border border-slate-200 text-slate-900 text-sm rounded-xl block p-2.5 transition-all outline-none
            ${icon ? "pl-10" : "pl-4"}
            focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 hover:border-slate-300
          `}
        />
      </div>
    </div>
  );
}
